import React, { useEffect, useState, useRef } from "react";
import { Card, Table, TableBody, TableCell, TableContainer, TablePagination, TableRow, Box } from "@material-ui/core";
import CloseIcon from '@mui/icons-material/Close';
import useStore from 'src/contexts/AuthProvider'
import { styled } from '@mui/material/styles';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import { useMutation, useQuery } from 'react-query';
import { FAQ_API_URL } from "src/api/axios";
import UserListHead from "src/components/user/UserListHead";
import useAxiosPrivate from "src/hooks/useAxiosPrivate";
import EditPenIcon from 'src/svgComponents/EditPenIcon'
import LoadingScreen from 'src/components/LoadingScreen'
import BinIcon from 'src/svgComponents/BinIcon'
import Stack from '@mui/material/Stack';
import { Button, Chip, IconButton, InputBase, Paper, TextField,Typography } from "@mui/material";
import SearchIcon from "src/svgComponents/SearchIcon";
import { useSnackbar } from "notistack";
import moment from 'moment'
import AppTooltip from "src/components/common/AppTooltip";
import { Form, FormikProvider, useFormik } from "formik"
import * as Yup from "yup";
import { Dialog, DialogActions, DialogContent, DialogTitle, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Editor } from '@tinymce/tinymce-react';

const FAQ = () => {
   const { enqueueSnackbar } = useSnackbar();
   const theme = useTheme();
   const axiosPrivate = useAxiosPrivate();
   const editorRef = useRef(null);

   const [page, setPage] = useState(0);
   const [rowsPerPage, setRowsPerPage] = useState(10);
   const [order, setOrder] = useState('desc');
   const [orderBy, setOrderBy] = useState('createdAt');
   const [filterName, setFilterName] = useState('');
   const [tableData, setTableData] = useState([]);
   const [modelTitle, setmodelTitle] = useState("");
   const [openModal, setOpenModal] = useState(false);
   const [deleteId, setdeleteId] = useState("");
   const [id, setId] = useState("");
   const [loding, setLoding] = useState(false);
   const [open, setOpen] = useState(false);
   const [editorValue, setEditorValue] = useState();
   const permissionsData = useStore(state => state.permissions);

   const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

   const completedSchema = Yup.object().shape({
      question: Yup.string()
         .min(2, "Question can set of between 10 and 500 characters!")
         .max(500, "Question can set of between 10 and 500 characters!")
         .required("Question is required!"),
      answer: Yup.string()
         .min(2, "Answer can set of between 2 and 5000 characters!")
         .max(5000, "Answer can set of between 2 and 5000 characters!")
         .required("Answer is required!")
   })

   const formik = useFormik({
      initialValues: {
         question: "",
         answer: ""
      },
      validationSchema: completedSchema,
      onSubmit: async (values, { resetForm, setFieldError, setSubmitting }) => {
         const informationObj = {
            question: values.question,
            answer: values.answer
         }
         if (id == "") {
            await addPage(informationObj)
         } else {
            await updateAdmin(informationObj)
         }
         resetForm();
         setSubmitting(false);
      }
   })

   const { errors, touched, setFieldValue, handleSubmit, setFieldError, setFieldTouched, getFieldProps } = formik;

   const { mutateAsync: addPage } = useMutation(
      async (data) => {
         return await axiosPrivate.post(FAQ_API_URL.addFaq, data)
      },
      {
         onSuccess: ({ data }) => {
            enqueueSnackbar("Page Add Successfully ", {
               variant: "success",
               anchorOrigin: { vertical: "top", horizontal: "right" },
               autoHideDuration: 2000,
            });
            handleCloseModal();
            refetch();
         },
         onError: (error) => {
            const errorData = error.response.data.errors;
            if (error.response?.data?.message) {
               enqueueSnackbar(error.response?.data?.message, {
                  variant: "error",
                  anchorOrigin: { vertical: "top", horizontal: "right" },
                  autoHideDuration: 2000,
               });
            }

            Object.keys(errorData).forEach((key) => {
               if (key === "question") {
                  setFieldError(key, errorData[key]);
               } else {
                  setFieldError(key, errorData[key]);
               }
            });
         },
      }
   );

   const { mutateAsync: updateAdmin } = useMutation(
      async (data) => {
         return await axiosPrivate.put(FAQ_API_URL.editFaq + id, data)
      },
      {
         onSuccess: ({ data }) => {
            refetch();
            enqueueSnackbar("Update successfully ", {
               variant: "success",
               anchorOrigin: { vertical: "top", horizontal: "right" },
               autoHideDuration: 2000,
            });
            handleCloseModal();
         },
         onError: (error) => {
            const errorData = error.response.data.errors;
            if (error.response?.data?.message) {
               enqueueSnackbar(error.response?.data?.message, {
                  variant: "error",
                  anchorOrigin: { vertical: "top", horizontal: "right" },
                  autoHideDuration: 2000,
               });
            }

            Object.keys(errorData).forEach((key) => {
               if (key === "question") {
                  setFieldError(key, errorData[key]);
               } else {
                  setFieldError(key, errorData[key]);
               }
            });
         },
      }
   );

   const StyledTableRow = styled(TableRow)(({ theme }) => ({
      '&:nth-of-type(odd)': {
         backgroundColor: '#ffffff',
      },
      '&:nth-of-type(even)': {
         background: "linear-gradient(0deg, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.6)), #F4F5F7",
      },
      // hide last border
      '& td, & th': {
         border: 0,
      },
   }));

   const TABLE_HEAD = [
      { id: 'question', label: 'Question', alignRight: false },
      { id: 'answer', label: 'Answer', alignRight: false },
      { id: 'status', label: 'Status', alignRight: false },
      { id: 'createdAt', label: 'Created at', alignRight: false },
      { id: 'action', label: 'Action', alignRight: false },
   ];

   function descendingComparator(a, b, orderBy) {
      if (b[orderBy] < a[orderBy]) {
         return -1;
      }
      if (b[orderBy] > a[orderBy]) {
         return 1;
      }
      return 0;
   }

   function getComparator(order, orderBy) {
      return order === 'desc'
         ? (a, b) => descendingComparator(a, b, orderBy)
         : (a, b) => -descendingComparator(a, b, orderBy);
   }
   function applySortFilter(array, comparator) {
      const stabilizedThis = array.map((el, index) => [el, index]);
      stabilizedThis.sort((a, b) => {
         const order = comparator(a[0], b[0]);
         if (order !== 0) return order;
         return a[1] - b[1];
      });
      return stabilizedThis.map((el) => el[0]);
   }
   async function getStaticPages(page, filterName) {
      const response = await axiosPrivate.get(FAQ_API_URL.getFaq, { params: { type: '1', page: page + 1, search: filterName, limit: rowsPerPage } })
      return response.data[0];
   }

   const { isLoading, data: staticPageList, refetch } = useQuery(['userData', page, filterName], () => getStaticPages(page, filterName), { keepPreviousData: true, })

   useEffect(() => {
      if (staticPageList) {
         setTableData(staticPageList.data);
         setRowsPerPage(staticPageList?.metadata.length != 0 ? staticPageList?.metadata[0].limit : 10);
      }
      if (staticPageList?.metadata.length != 0 && staticPageList?.metadata[0].hasMoreData == true) {
         getStaticPages(page + 1);
      }
      setTimeout(() => {
         setLoding(false);
      }, 500);
   }, [staticPageList])
   if (isLoading) return <LoadingScreen />

   const handleChangePage = (event, newPage) => {
      setPage(newPage);
   };

   const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
      setTimeout(() => {
         refetch();
      }, 500);
   };

   const handleFilterByName = (event) => {
      setFilterName(event.target.value.trim());
      setPage(0);
      getStaticPages(page, filterName)
      refetch();
   };

   const handleRequestSort = (event, property) => {
      const isAsc = orderBy === property && order === 'asc';
      setOrder(isAsc ? 'desc' : 'asc');
      setOrderBy(property);
   };

   const filteredFaq = applySortFilter(tableData, getComparator(order, orderBy));

   const handleOpenModalAdd = () => {
      setId('');
      setFieldValue('question', "")
      setFieldValue('answer', "")
      setmodelTitle('Add FAQ ')
      setOpenModal(true);
   }
   const handleOpenModalUpdate = (row) => {
      setId(row._id)
      setFieldValue('question', row.question)
      setFieldValue('answer', row.answer)
      setmodelTitle('Update FAQ ')
      setOpenModal(true);
   }
   const handleCloseModal = () => {
      setId('');
      setEditorValue('');
      setFieldError("question", "")
      setFieldTouched("question", "")
      setFieldError("answer", "")
      setFieldTouched("answer", "")
      setOpenModal(false);
   };

   async function deleteCMSPage() {
      const response = await axiosPrivate.delete(FAQ_API_URL.deleteFaq + deleteId)
      if (response.status == 200) {
         refetch();
         enqueueSnackbar("Page deleted successfully!", {
            variant: "success",
            anchorOrigin: { vertical: "top", horizontal: "right" },
            autoHideDuration: 2000
         });
      } else {
         enqueueSnackbar("something went wrong!", {
            variant: "error",
            anchorOrigin: { vertical: "top", horizontal: "right" },
            autoHideDuration: 2000
         });
      }
      handleClose();
      refetch();
   }
   const handleClose = () => {
      setOpen(false);
   };
   const handleClickOpen = (categoryId) => {
      setdeleteId(categoryId);
      setOpen(true);
   };

   const changeStatus = async (id) => {
      const response = await axiosPrivate.put(FAQ_API_URL.changeStatus + id)
      if (response?.data?.message) {
         enqueueSnackbar(response?.data?.message, {
            variant: "success",
            anchorOrigin: { vertical: "top", horizontal: "right" },
            autoHideDuration: 2000,
         });
      }
      refetch()
   }

   return (
      <>
         {loding ? <LoadingScreen /> : <>
            <div className="dashboard_header mb-4">
            <h5 className="card-header">FAQ</h5>

               {/* <h4 className="app_text_20_semibold mb-0 d-flex align-items-center">Sub Admin</h4> */}
               <Paper component="form" className='dashboard_searchbox col-lg-4'>
                  <IconButton>
                     <SearchIcon />
                  </IconButton>
                  <InputBase
                     fullWidth
                     sx={{ flex: 1 }}
                     placeholder="Search ..."
                     onChange={(e) => handleFilterByName(e)}
                     onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }}
                  />
               </Paper>
               <Stack direction={"row"} className="d-flex align-items-center" spacing={2}>
                  {permissionsData?.FAQ?.substring(1, 2) == "1"
                     ? <AppTooltip title="Add FAQ " placement="bottom"><Button className="dashboard_light_bg_icon_btn" onClick={handleOpenModalAdd}><AddCircleOutlineOutlinedIcon style={{ fontSize: 18, color: "#000080" }} /></Button></AppTooltip> : ''}
               </Stack>
            </div>
            <Dialog
               fullScreen={fullScreen}
               open={open}
               onClose={handleClose}
               aria-labelledby="responsive-dialog-title"
            >
               <DialogTitle id="responsive-dialog-title" className='m-auto'>
                  {"Are you sure you want to delete?"}
               </DialogTitle>
               <DialogContent>
               </DialogContent>
               <DialogActions className='m-auto'>
                  <Button className="theme_button_view" variant="contained" autoFocus onClick={handleClose}>
                     Cancel
                  </Button>
                  <Button className="theme_button" variant="contained" onClick={() => deleteCMSPage()} autoFocus>
                     Delete
                  </Button>
               </DialogActions>
            </Dialog>
            <Card>
               <TableContainer>
                  <Table>
                     <UserListHead
                        headLabel={TABLE_HEAD}
                        rowCount={staticPageList?.length !== 0 ? staticPageList?.total : 0}
                        onRequestSort={handleRequestSort}
                     />
                     {filteredFaq.length > 0 ?
                        <TableBody>
                           {filteredFaq.map((row, key) => {
                              return (
                                 <StyledTableRow key={key}>
                                    <TableCell component="th" scope="row"> {row.question ? row.question : ""} </TableCell>
                                    <TableCell component="th" scope="row"> {row.answer ? row.answer : ""} </TableCell>
                                    <TableCell>
                                       <Stack direction="row" spacing={3}>
                                          {
                                             row.status == 1 ? <Chip variant="contained" label="Enable" className="app_status_chip accepted" onClick={() => changeStatus(row._id)} /> : <Chip variant="contained" className="app_status_chip invalid" label="Disable" onClick={() => changeStatus(row._id)} />
                                          }
                                       </Stack>
                                    </TableCell>
                                    <TableCell align="left"> {moment(row.createdAt).format("MMM DD YYYY h:mm A")} </TableCell>
                                    <TableCell>
                                       <Stack direction="row" spacing={3}>
                                          {
                                             permissionsData?.SubAdmin?.substring(1, 2) == "1" ?
                                                <AppTooltip title="Edit" placement="bottom"><Button sx={{ "&:hover": { bgcolor: "transparent" } }} onClick={() => handleOpenModalUpdate(row)} variant="text" className="user_list_row_btn"><EditPenIcon /></Button></AppTooltip> : ''
                                          }
                                          {/* {
                                             permissionsData?.SubAdmin?.substring(3, 4) == "1" ?
                                                <AppTooltip title="Delete" placement="bottom"><Button variant="text" className="user_list_row_btn" onClick={() => handleClickOpen(row._id)} ><BinIcon /></Button></AppTooltip> : ""
                                          } */}
                                       </Stack>
                                    </TableCell>
                                 </StyledTableRow>
                              )
                           })}

                        </TableBody>
                        :

                        <TableBody>
                           <TableRow>
                              <TableCell align="center" colSpan={8} sx={{ py: 3 }}>
                                 <span className="app_text_16_semibold">No Data Found</span>
                              </TableCell>
                           </TableRow>
                        </TableBody>
                     }
                  </Table>
               </TableContainer>
               <TablePagination
                  component="div"
                  rowsPerPageOptions={[10, 20, 50, 100]}
                  count={staticPageList?.metadata.length != 0 ? staticPageList?.metadata[0].total : 0}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
               />
            </Card>
            <Dialog
               open={openModal}
               onClose={handleCloseModal}
               aria-labelledby="child-modal-title"
               aria-describedby="child-modal-description"
            >
               <DialogTitle>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                     <h4>{modelTitle}</h4>
                     <Button className="dashboard_light_bg_icon_btn" onClick={handleCloseModal} aria-label="delete">
                        <CloseIcon style={{ color: '#fff' }} />
                     </Button>
                  </Box>
               </DialogTitle>
               <DialogContent className="custom_form_mui pt-2">
                  <FormikProvider value={formik}>
                     <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                        <div className="row">
                           <div className="col-lg-12">
                              <div className="form-group mb-3">
                                 <TextField label='Question' name='question' autoComplete='off' fullWidth variant='outlined'
                                    {...getFieldProps("question")}
                                    error={Boolean(touched.question && errors.question)}
                                    helperText={touched.question && errors.question}
                                 />
                              </div>
                           </div>
                           <div className="col">
                              <div className="form-group mb-4">
                              <TextField
                              label="Answer"
                              name="answer"
                              autoComplete="off"
                              sx={{
                                 "& .MuiInputBase-input.MuiOutlinedInput-input": {
                                    minHeight: "3.5rem",
                                 },
                              }}
                              fullWidth
                              multiline
                              variant="outlined"
                              {...getFieldProps("answer")}
                              // error={Boolean(touched.answer && errors.answer)}
                              // helperText={touched.answer && errors.answer}
                              />
                              {errors.answer && touched.answer && <Typography color="error">{errors.answer}</Typography>}
                              </div>
                           </div>
                        </div>
                        <div className="col">
                           <div className="col-md-8 m-auto">
                              <Button
                                 type="submit"
                                 fullWidth
                                 variant="contained"
                                 className="my-3 text-lowercase text-white app_bg_primary app_text_16_semibold app_btn_lg"
                              >
                                 submit
                              </Button>
                           </div>
                        </div>
                     </Form>
                  </FormikProvider>
               </DialogContent>
            </Dialog>
         </>
         }
      </>
   )
}

export default FAQ